import css from 'styled-jsx/css';
import { isRTL } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/rem';
  @import 'src/common/styling/_mixins-scss/screen-size';

  .PaymentsTable {
    .ReactDataTable__wrapper {
      overflow-x: auto;
      .ReactDataTable {
        min-width: 1360px !important;
        tr {
          grid-template-columns:
            minmax(80px, 0.4fr) /* ID */
            minmax(140px, 1fr) /* Amount */
            minmax(120px, 1fr) /* Type */
            minmax(130px, 1fr) /* Account */
            minmax(130px, 1fr) /* Payment method */
            minmax(150px, 1fr) /* Created */
            minmax(190px, 1.7fr) /* Status */
            minmax(320px, 3fr); /* Tags */
        }

        .ReactDataTable__tbody-row {
          height: 75px;
          padding: 0 10px;
        }

        .ReactDataTable__tbody-cell {
          display: flex;
          padding: 7px;
          align-items: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          span {
            font-size: rem(14px);
          }

          &:nth-child(2) {
            .MoneyCell__withdraw,
            .MoneyCell__wallet_withdraw,
            .MoneyCell__deposit,
            .MoneyCell__wallet_deposit,
            .MoneyCell__compensation,
            .MoneyCell__wallet_freeze,
            .MoneyCell__wallet_refund {
              position: relative;
              padding: rem(${isRTL ? '5px 30px 5px 0' : '5px 0 5px 30px'});

              svg {
                width: rem(20px);
                height: rem(19px);
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: ${isRTL ? 'auto' : '0'};
                right: ${isRTL ? '0' : 'auto'};
              }
            }
          }

          &:last-child {
            font-size: 13px; /* tags */
          }

          .StatusCell {
            overflow: hidden;
            text-overflow: ellipsis;
            top: 2px;
            font-size: 11px;
          }
        }
      }
    }

    &__tags {
      display: flex;
      align-items: center;
      gap: 8px;

      &__caption {
        text-wrap: nowrap;
      }
    }

    /* --- Responsive layout --- */
    .ResponsiveTable__thead {
      min-width: 340px !important;
      display: flex;

      span {
        text-align: center;
        padding: 5px 0;

        &:nth-child(1) {
          flex: 1; /* ID */
        }

        &:nth-child(2) {
          flex: 3; /* Amount */
        }

        &:nth-child(3) {
          flex: 2; /* Type */
        }

        &:nth-child(4) {
          flex: 2; /* Account */
        }
      }
    }

    .ResponsiveTable__row {
      .ResponsiveTable__preview-main {
        display: flex;
        align-items: center;
        gap: 8px;
        height: 44px;

        .ResponsiveTable__row-item {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:nth-child(1) {
            flex: 1; /* ID */
          }

          &:nth-child(2) {
            flex: 3; /* Amount */
            .MoneyCell__withdraw,
            .MoneyCell__wallet_withdraw,
            .MoneyCell__deposit,
            .MoneyCell__wallet_deposit,
            .MoneyCell__compensation,
            .MoneyCell__wallet_freeze,
            .MoneyCell__wallet_refund {
              position: relative;
              padding: rem(${isRTL ? '5px 23px 5px 0' : '5px 0 5px 23px'});

              svg {
                width: rem(18px);
                height: rem(17px);
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: ${isRTL ? 'auto' : '0'};
                right: ${isRTL ? '0' : 'auto'};
              }

              .MoneyCell__inner span {
                font-size: 13px;
              }
            }
          }

          &:nth-child(3) {
            flex: 2; /* Type */
          }

          &:nth-child(4) {
            flex: 2; /* Account */
          }
        }
      }

      .ResponsiveTable__preview-description {
        .ResponsiveTable__row-item {
          justify-content: flex-start;
          padding-left: 10%;
        }

        .StatusCell {
          font-size: rem(12px) !important;
        }
      }

      .ResponsiveTable__details-item {
        padding-left: 15%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .PaymentsTable {
      .ReactDataTable__tbody-cell {
        &:nth-child(1) {
          a {
            color: ${colors.black.hex};
          }
        }

        &:nth-child(2) {
          span:first-child {
            color: ${colors.success.hex};
          }
        }
      }

      .ResponsiveTable__row-item:first-child span:first-child {
        color: ${colors.success.hex};
      }

      .MoneyCell__withdraw,
      .MoneyCell__wallet_withdraw {
        .MoneyCell__inner span {
          color: ${colors.error.hex} !important;
        }

        :global(svg) {
          fill: ${colors.error.hex};

          :global(path) {
            fill: ${colors.error.hex};
          }
        }
      }

      .MoneyCell__deposit,
      .MoneyCell__wallet_deposit,
      .MoneyCell__compensation,
      .MoneyCell__wallet_freeze,
      .MoneyCell__wallet_refund {
        .MoneyCell__inner span {
          color: ${colors.success.hex} !important;
        }

        :global(svg) {
          fill: ${colors.success.hex};

          :global(path) {
            fill: ${colors.success.hex};
          }
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
